
import * as actions from '../constants/departmentConstants';
//import axios from 'axios';
const getToken = () => {
    return JSON.parse(localStorage.getItem("key"));
};
const getUserId = () => {
    return Number(localStorage.getItem("userId"));
};
const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "",
};
export const fetchDepartment = () => async (dispatch) => {
	dispatch({ type: actions.FETCH_DEPARTMENT_REQUEST });
    let SERVER_URL = process.env.REACT_APP_API_URL;
	try {
		 await fetch(SERVER_URL +`api/common/department_list`, {
            method: "GET",
            headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
          }).then((res) => res.json())
          .then((data) => {
           
            dispatch({ type: actions.FETCH_DEPARTMENT_SUCCESS, payload: data.result });
          })
		
	} catch (error) {
		dispatch({ type: actions.FETCH_DEPARTMENT_FAILED, payload: error.message });
		console.log(error.message);
	}
};